<div id="outer-container">
  <span id="title">{{'remoteControl_DownloadDeviceLogsSelectorTitle' | xsI18n }}</span>

  <div id="item-container">
    <div *ngFor="let category of categories | keyvalue; trackBy: trackByKey">
      <mat-checkbox class="category-checkbox" [checked]="isCategoryChecked(category.key)" disableRipple="true"
        (change)="onCategoryChanged(category.key, $event)">{{category.key}} </mat-checkbox>
    </div>
  </div>

  <div id="footer">
    <label id="selected-description">{{selectedCategoriesCount}}/{{totalCategoriesCount}}
      {{'ticket_RemoteControlTabs_DeviceLogs_Selected_Caption' | xsI18n }}</label>

    <button class="xs-btn btn-primary btn-download" id="download-button" (click)="onDownloadClicked()"
      [disabled]="!isDownloadEnabled">{{'ticket_RemoteControlTabs_DeviceLogs_Download_Caption' | xsI18n }}</button>

    <button class="xs-btn btn-outline btn-cancel" id="cancel-button"
      (click)="onCancelClicked()">{{'xs_cancel_label' | xsI18n }}</button>
  </div>
</div>
